import { ReportSettingState } from '..';
import { ClientCustomCalendarModel, ReportType } from '../../../../models';
import { getReportEndDateDisclosure } from './getReportEndDateDisclosure';
import { getReportEndDateFiscalRollforward } from './getReportEndDateFiscalRollforward';
import { getReportEndDateRollforward } from './getReportEndDateRollforward';
import { getReportEndDateROUAssets } from './getReportEndDateROUAssets';
import { getReportEndDateStartEnd } from './getReportEndDateStartEnd';
import { getReportEndDateSublease } from './getReportEndDateSublease';
import { getReportEndDateAssetAmort } from './getReportEndDateAssetAmort';
import { getReportEndDateAp } from './getReportEndDateAp';

const GETTERS = {
  [ReportType.startEnd]: getReportEndDateStartEnd,
  [ReportType.rollforward]: getReportEndDateRollforward,
  [ReportType.fiscalRollforward]: getReportEndDateFiscalRollforward,
  [ReportType.disclosure]: getReportEndDateDisclosure,
  [ReportType.sublease]: getReportEndDateSublease,
  [ReportType.rouAssets]: getReportEndDateROUAssets,
  [ReportType.assetAmort]: getReportEndDateAssetAmort,
  [ReportType.ap]: getReportEndDateAp,
  // We don't validate report enddate for other report types
};

export const getReportEndDate = (
  reportType: ReportType,
  reportSettingState: ReportSettingState,
  customCalendarSettings?: ClientCustomCalendarModel,
): Date => {
  const getter = GETTERS[reportType];
  if (!getter) return null;
  return getter(reportSettingState, customCalendarSettings);
};
